import { useMicBlockedStore } from '@modules/phone/store/mic-blocked.store';

const MICROPHONE_ERROR_CODES = [31208, 31401, 31402];
const MICROPHONE_ERROR_NAMES = ['NotAllowedError', 'NotFoundError', 'NotReadableError'];

export function isMicrophoneError(error: unknown): boolean {
  const { name, code } = (error ?? {}) as { name?: string; code?: number };

  return (
    (!!name && MICROPHONE_ERROR_NAMES.includes(name)) ||
    (typeof code === 'number' && MICROPHONE_ERROR_CODES.includes(code))
  );
}

export async function requestMicrophoneAccess(): Promise<boolean> {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach((track) => track.stop());
    return true;
  } catch {
    return false;
  }
}

export async function requireMicAccess(): Promise<boolean> {
  const isGranted = await requestMicrophoneAccess();
  if (!isGranted) useMicBlockedStore.getState().open();
  return isGranted;
}
